import { BadgeCheck, ClipboardList, Hammer, HeartHandshake, Home, MessagesSquare, PackageCheck, Thermometer } from "lucide-react";

export const ABOUT_NAV = [["wie-wij-zijn", "Wie wij zijn"], ["wat-wij-doen", "Wat wij doen"], ["kwaliteit", "Profielsystemen"],
  ["vakmanschap", "Vakmanschap"], ["uitgangspunten", "Uitgangspunten"], ["werkgebied", "Werkgebied"]];

export const ABOUT_POINTS = ["Complete levering en montage, inclusief isolatieglas", "Duitse GEALAN-profielsystemen voor kunststof kozijnen",
  "Hoofdmonteur met ruim 20 jaar praktijkervaring"];

// Alleen door de eigenaar bevestigde bedrijfsgegevens.
export const COMPANY_FACTS = [
  ["Bedrijfsnaam", "Maas Kozijn"],
  ["Onderneming", "Handelsnaam van Koning Aannemersbedrijf (eenmanszaak)"],
  ["Eigenaar", "Hilmi Yildirimer"],
  ["Vestigingsplaats", "Maassluis"],
  ["Werkgebied", "Zuid-Holland"],
  ["Voor wie", "Particuliere woningeigenaren"],
];

export const ACTIVITIES = ["Inmeten van de kozijnen bij u thuis", "Levering van nieuwe kozijnen, inclusief isolatieglas", "Demontage van de bestaande kozijnen",
  "Professionele montage", "Afdichting van de aansluitingen", "De afgesproken binnen- en buitenafwerking"];

export const PRODUCT_LINKS = [
  { href: "/kunststof-kozijnen", title: "Kunststof kozijnen", text: "Onderhoudsarm en goed isolerend." },
  { href: "/aluminium-kozijnen", title: "Aluminium kozijnen", text: "Slanke profielen, strakke uitstraling." },
  { href: "/schuifpuien", title: "Schuifpuien", text: "Kunststof, aluminium en hefschuifpuien." },
  { href: "/deuren", title: "Deuren", text: "Voor-, achter- en tuindeuren." },
];

export const PRINCIPLES = [
  { icon: Home, title: "Betaalbare woningverbetering", text: "Kwalitatieve kozijnen die passen bij uw woning én uw budget, zonder onnodige extra's." },
  { icon: Thermometer, title: "Isolatie en wooncomfort", text: "Goed isolerende profielen en glas voor een warmer, stiller en comfortabeler huis." },
  { icon: BadgeCheck, title: "Kwalitatieve kozijnen", text: "Profielsystemen waarvan we de kwaliteit kennen, zoals GEALAN voor kunststof." },
  { icon: Hammer, title: "Vakkundige montage", text: "Waterpas en in lood geplaatst, zorgvuldig afgedicht en netjes afgewerkt." },
  { icon: ClipboardList, title: "Transparante offertes", text: "In de offerte staat precies welke werkzaamheden en materialen zijn inbegrepen." },
  { icon: HeartHandshake, title: "Persoonlijke betrokkenheid", text: "Eén vast aanspreekpunt dat uw woning en uw wensen kent." },
  { icon: MessagesSquare, title: "Duidelijke communicatie", text: "Geen vakjargon of verkooppraat: u weet vooraf wat er gebeurt en wanneer." },
  { icon: PackageCheck, title: "Complete levering en montage", text: "Van inmeten tot afwerking in één hand; geen losse partijen die u zelf moet regelen." },
];

export const GEALAN_SYSTEMS = [
  { slug: "gealan-s-9000", name: "GEALAN S 9000" },
  { slug: "gealan-s-9000-nl", name: "GEALAN S 9000 NL" },
];
